<template lang="pug">
#certificacao-bloco-informacoes
    el-skeleton(:loading='carregando', animated)
        template(slot='template')
            .skeleton-bloco-informacoes__interno
                el-skeleton-item.icone(variant='circle')

                .width-interno
                    el-skeleton-item(variant='p')
                    el-skeleton-item.width-interno(variant='p')

                el-skeleton-item.numero(variant='rect')
        template
            slot
</template>

<script>
export default {
    name: 'BlocoInformacaoCertificacaoSkeleton',
    props: {
        carregando: {
            type: Boolean,
            default: () => false
        }
    }
};
</script>

<style lang="scss">
#certificacao-bloco-informacoes {
    .width-interno {
        width: 50%;
    }

    flex-wrap: wrap;
    & > div {
        flex-grow: 1;
    }

    .skeleton-bloco-informacoes__interno {
        margin-top: 3px;
        min-height: 88px;
        width: 100%;
        background: #d6d6d6;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .icone {
            width: 28px;
            height: 28px;
        }

        .numero {
            width: 10%;
            height: 30px;
        }
    }
}

@media only screen and (max-width: 1380px) {
    #certificacao-bloco-informacoes {
        min-width: 32.2% !important;
        flex-grow: 0;
    }
}
</style>
